export enum SubmitMessages {
  FORM_UPLOADED = "Form uploaded successfully",
}

export default SubmitMessages;
